<div #chart data-testid="sparkline" class="sparkline"></div>
